export const ENABLE_WORDPRESS = false;
export const ENABLE_ANCHOR_TO_WP_ENTRYPOINTS = false;
